import { useQuery } from 'react-query';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import ResourceGroupCard from './ResourceGroupCard';
import { GetResourceGroupsFn } from '../../data/apiCalls';
import {
	LOGIN_URL,
	ACCOUNT_ACTIVATION_URL,
} from '../../scripts/navigationItems';
import NoResultsOverlay from '../Errors/NoResultsOverlay';
import ResourceGroupListSkeleton from './ResourceGroupListPage.skeleton';

const ResourceGroupListPage = () => {
	// Only Providers use this component
	const pageTitle = 'Resources - Providers';
	const {
		data: {
			status = undefined,
			data: {
				resultCode = undefined,
				data: { resourceGroups = [] } = {},
			} = {},
		} = {},
		isLoading,
		isError,
	} = useQuery(['ProviderResourceGroups'], () => GetResourceGroupsFn(true), {
		staleTime: Infinity,
	});
	const showNoResultsOverlay = isError || (status >= 400 && status <= 505);

	return (
		<Container sx={{ pb: 8 }}>
			<Typography variant='h4' sx={{ mt: 4, mb: 3 }}>
				{pageTitle}
			</Typography>
			<Divider sx={{ mb: 2 }} />
			<Typography variant='body1' sx={{ mb: { xs: 3, md: 8 } }}>
				If you are a contracted provider,{' '}
				<Link href={LOGIN_URL}>log in</Link> or{' '}
				<Link href={ACCOUNT_ACTIVATION_URL}>activate your account</Link>{' '}
				to access additional resources.
			</Typography>
			{isLoading && <ResourceGroupListSkeleton />}
			{showNoResultsOverlay && (
				<Container sx={{ pt: 3 }}>
					<NoResultsOverlay
						resultCode={resultCode}
						statusCode={status}
					/>
				</Container>
			)}
			{!isLoading && !showNoResultsOverlay && (
				<Grid container spacing={2}>
					{resourceGroups
						.sort((a, b) =>
							a.displayName.localeCompare(b.displayName)
						)
						.map(group => (
							<Grid
								item
								xs={12}
								sm={6}
								md={4}
								key={group.resourceGroupId}
							>
								<ResourceGroupCard resourceGroupData={group} />
							</Grid>
						))}
				</Grid>
			)}
		</Container>
	);
};

export default ResourceGroupListPage;
